import { render, staticRenderFns } from "./BaseDoubleClickSubmitButton.vue?vue&type=template&id=69ac0527&scoped=true&"
import script from "./BaseDoubleClickSubmitButton.vue?vue&type=script&lang=js&"
export * from "./BaseDoubleClickSubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseDoubleClickSubmitButton.vue?vue&type=style&index=0&id=69ac0527&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ac0527",
  null
  
)

export default component.exports